import React from "react";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa"; // Importing relevant icons from react-icons

const ConnectWithUs = () => {
  return (
    <div className='py-4 mt-6 '>
      <div className='text-center px-4'>
        <h2 className='text-xl md:text-3xl font-bold mb-4'>Connect with Us</h2>
        <p className='mb-8 text-md'>
          We're here to assist you. Please reach out to us through any of the
          following contact methods:
        </p>

        {/* Contact Information with Icons in 3 Boxes */}
        <div className='grid grid-cols-1 sm:grid-cols-3 gap-6'>
          {/* Email Box */}
          <div className='bg-white p-6 rounded-lg shadow-lg flex flex-col items-center space-y-4 text-sm'>
            <FaEnvelope className='text-4xl text-blue-600' />
            <div className='text-center'>
              <strong className='block'>Email:</strong>
              <a
                href='mailto:admin@shivaauto.net'
                className='text-blue-500 hover:underline'
              >
                admin@shivaauto.net
              </a>
            </div>
          </div>

          {/* Location Box */}
          <div className='bg-white p-6 rounded-lg shadow-lg flex flex-col items-center space-y-4 text-sm'>
            <FaMapMarkerAlt className='text-4xl text-red-600' />
            <div className='text-center'>
              <strong className='block'>Location:</strong>
              <a
                href='https://maps.app.goo.gl/qrJjakPLXCru2MkH6'
                target='_blank'
                rel='noopener noreferrer'
                className='text-red-500 hover:underline'
              >
                Dubey Ka Parao, G.T Road Aligarh, Uttar Pradesh - 202001
              </a>
            </div>
          </div>

          {/* Contact Number Box */}
          <div className='bg-white p-6 rounded-lg shadow-lg flex flex-col items-center space-y-4 text-sm'>
            <FaPhoneAlt className='text-4xl text-green-600' />
            <div className='text-center'>
              <strong className='block'>Contact No:</strong>
              <a
                href='tel:+919897794551'
                className='text-green-500 hover:underline'
              >
                +91 98977 94551
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectWithUs;
